// SPDX-License-Identifier: AGPL-3.0-or-later
import {SettingsSection} from '@app/features/app/components/dialogs/shared/SettingsSection';
import styles from '@app/features/konvo_today/components/settings/CustomiseHome.module.css';
import HomePreferences, {HOME_UNDO_SEND_CHOICES} from '@app/features/konvo_today/state/HomePreferences';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';

const DURATION_DESCRIPTOR = msg({
	message: 'Undo send duration',
	comment: 'Customise Home: setting for how long a reply waits before being sent.',
});
const HINT_DESCRIPTOR = msg({
	message:
		'Choose how long replies from Home wait so you can undo. Off sends immediately. Send now skips the wait. Saved on this device.',
	comment: 'Customise Home: explanation of the undo send duration setting.',
});
const OFF_DESCRIPTOR = msg({
	message: 'Off',
	comment: 'Customise Home: disable undo send and send replies immediately.',
});
const SECONDS_DESCRIPTOR = msg({
	message: '{seconds} seconds',
	comment: 'Customise Home: undo send duration choice. {seconds} is 3, 5 or 7.',
});

export const HomeSendingSettings = observer(() => {
	const {i18n} = useLingui();
	const title = i18n._(DURATION_DESCRIPTOR);
	return (
		<SettingsSection
			id="konvo-home-undo-send"
			title={title}
			description={i18n._(HINT_DESCRIPTOR)}
			className={styles.bare}
		>
			<div className={clsx(styles.card, styles.chipsCard)}>
				<div
					className={styles.chips}
					role="radiogroup"
					aria-label={title}
					data-flx="konvo-today.customise-home.undo-send"
				>
					{HOME_UNDO_SEND_CHOICES.map((seconds) => {
						const selected = seconds * 1000 === HomePreferences.undoSendMs;
						return (
							<button
								key={seconds}
								type="button"
								role="radio"
								aria-checked={selected}
								className={clsx(styles.chip, selected && styles.chipOn)}
								onClick={() => HomePreferences.setUndoSendSeconds(seconds)}
								data-flx={`konvo-today.customise-home.undo-send.${seconds}`}
							>
								{seconds === 0 ? i18n._(OFF_DESCRIPTOR) : i18n._(SECONDS_DESCRIPTOR, {seconds})}
							</button>
						);
					})}
				</div>
			</div>
		</SettingsSection>
	);
});
